export const templates = Object.freeze({
  productsOutOfStock: 'PRODUCTS_OUT_OF_STOCK',
});

export const backendErrorCodes = Object.freeze({
  outOfStock: 'OUT_OF_STOCK',
});
